import { render, staticRenderFns } from "./SubmitAnswers.vue?vue&type=template&id=3fa06928&scoped=true&"
import script from "./SubmitAnswers.vue?vue&type=script&lang=js&"
export * from "./SubmitAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa06928",
  null
  
)

export default component.exports